// pdfUtils.js
import { data } from "autoprefixer";
import pdfjsLib from "./pdfWorker";
// import { diffWords } frosm "diff";

export async function getPdfText(file) {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  let text = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    text += content.items.map((item) => item.str).join(" ");
  }
  return text;
}

// export async function comparePdfs(file1, file2) {
//   const text1 = await getPdfText(file1);
//   const text2 = await getPdfText(file2);
//   const diff = diffWords(text1, text2);
//   return diff;
// }

const isEmpty = (string) => {
  let regex = /^\s+$/;

  return regex.test(string) || string === "";
};
const hasSpace = (string) => {
  let regex = /^[\s]+$/;

  return regex.test(string);
};

export async function getPdfHeadings(url) {
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  let headings = [];
  const outline = await pdf.getOutline();
  if (outline === null) {
    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const content = await page.getTextContent();
      const items = content.items;
      // console.log(items);
      items.forEach((item, index) => {
        // Example logic: identify headings based on font size or specific text patterns
        // This is a simple heuristic, you may need to refine it based on your PDFs

        if (item.fontName && !isEmpty(item.str) && item.height > 10) {
          const length = headings.length - 1;

          if (length >= 0 && headings[length].transform === item.transform[5]) {
            if (hasSpace(items[index - 1].str)) {
              headings[length].label += " " + item.str;
            } else {
              headings[length].label += item.str;
            }
          } else {
            headings.push({
              label: item.str,
              value: item.str + "-" + (i - 1),
              pageNumber: i - 1,
              transform: item.transform[5],
              data: item,
            });
          }
        }
      });
    }
  } else {
    headings = outline.map((val, index) => ({
      label: val.title,
      value: val.title + "-" + index,
      pageNumber: val.dest[0] || 0,
    }));
  }

  return headings;
}
